// extracted by mini-css-extract-plugin
export default {"add_button":"Partner_add_button__touTl","partners":"Partner_partners__M1PqO"};